import type { ServerRuntimeConfig } from '@/config/runtime/types';

let cachedConfig: ServerRuntimeConfig | null = null;

export function getServerRuntimeConfig(): ServerRuntimeConfig {
    if (cachedConfig) {
        return cachedConfig;
    }

    cachedConfig = {
        logLevel: process.env.BNEF_SERVER_LOG_LEVEL || 'debug',
        crescentEnv: process.env.BNEF_SERVER_CRESCENT_ENV as ServerRuntimeConfig['crescentEnv'],
        clientConfig: {
            buildId: process.env.BNEF_SERVER_BUILD_ID,
            environment: process.env.BNEF_SERVER_ENVIRONMENT,
            sentry: {
                enabled: process.env.BNEF_SERVER_SENTRY_ENABLED === 'true',
                dsn: process.env.BNEF_SERVER_SENTRY_DSN,
                clientDsn: process.env.BNEF_SERVER_SENTRY_CLIENT_DSN,
                tracesSampleRate: parseFloat(process.env.BNEF_SERVER_SENTRY_TRACES_SAMPLE_RATE || '0'),
                profilesSampleRate: parseFloat(process.env.BNEF_SERVER_SENTRY_PROFILES_SAMPLE_RATE || '0'),
            },
            services: {
                sailthruCustomerId: process.env.BNEF_SERVER_SERVICES_SAILTHRU_CUSTOMER_ID,
                clientAnalytics: {
                    debug: process.env.BNEF_SERVER_SERVICES_CLIENT_ANALYTICS_DEBUG === 'true',
                    bbAnalyticsMatomoSiteId: parseInt(
                        process.env.BNEF_SERVER_SERVICES_CLIENT_ANALYTICS_MATOMO_SITE_ID || '0'
                    ),
                    bbAnalyticsMatomoEnvId: parseInt(
                        process.env.BNEF_SERVER_SERVICES_CLIENT_ANALYTICS_MATOMO_ENV_ID || '0'
                    ),
                },
            },
        },
    };

    return cachedConfig;
}
